import { forwardRef } from "react";
function SvgRawLinkIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        stroke="#1D1D1D"
        strokeWidth={2}
        d="m13.9 8.313-1.316-1.316a4 4 0 1 0-5.657 5.657l1.317 1.316m1.856 1.855 1.316 1.317a4 4 0 0 0 5.657-5.657l-1.317-1.316"
      />
      <path
        stroke="#1D1D1D"
        strokeLinecap="round"
        strokeWidth={2}
        d="m9.879 9.879 4.242 4.242"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawLinkIcon);
export default ForwardRef;
